import { createSigningService } from '@workpay/ds-shared/services/signingService';
import { publicClient } from '@lib/axios';

export const signingService = createSigningService(publicClient);
